import React from 'react';
import { cx } from '../cx';

// D-09 §15.29 — Avatar (.avatar · .sq 정사각 · AvatarGroup)
export interface AvatarProps extends React.HTMLAttributes<HTMLSpanElement> {
  square?: boolean;
  src?: string;
  alt?: string;
}

export function Avatar({ square, src, alt, className = '', children, ...props }: AvatarProps) {
  return (
    <span className={cx('avatar', square && 'sq', className)} {...props}>
      {src ? (
        <img src={src} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      ) : (
        children
      )}
    </span>
  );
}

export function AvatarGroup({ className = '', children, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cx('avatar-group', className)} {...props}>
      {children}
    </div>
  );
}
